import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket: any;
  // private serverUrl: string = 'http://localhost:5000';  // URL del server Flask con WebSocket
  // private serverUrl: string = 'https://andron.fdcmessina.org/andron';  // URL del server Flask con WebSocket
  private serverUrl: string = 'wss://andron.fdcmessina.org/';  // URL del server Flask con WebSocket


  constructor() {}
/*
  // Connessione al server WebSocket
  connect(token:string) {
    // console.info(this.socket);
    if (!this.socket || !this.socket.connected) {
      this.socket = io(this.serverUrl, {
          "query": { "token": token }
        });
      // Gestione della connessione riuscita
      this.socket.on('connect', () => {
        console.log('Connessione WebSocket riuscita');
      });
    }
  }
*/
  connect(token: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Verifica se il socket non esiste o non è connesso
      if (!this.socket || !this.socket.connected) {
        // Crea una connessione socket.io con il token passato come query
        this.socket = io(this.serverUrl, {
          // path: "/socket.io",  // Assicurati che il percorso sia corretto
          query: { token: token },
          transports: ["websocket"], // Forza WebSocket senza polling HTTP
          secure: true,  // Obbliga la connessione sicura
          reconnection: true,  // Abilita la riconnessione automatica
          reconnectionAttempts: 5,  // Numero di tentativi di riconnessione
          reconnectionDelay: 1000,  // Ritardo tra i tentativi
        });
  
        // Gestione della connessione riuscita
        this.socket.on('connect', () => {
          // console.log('Connessione WebSocket riuscita');
          resolve();  // Risolvi la Promise quando la connessione è avvenuta
        });
  
        // Gestione degli errori di connessione
        this.socket.on('connect_error', (error) => {
          // console.error('Errore nella connessione WebSocket', error);
          reject(error);  // Rifiuta la Promise in caso di errore
        });
      } else {
        resolve();  // Se la socket è già connessa, risolvi immediatamente la Promise
      }
    });
  }

  // Unisciti alla room
  joinChat(ricevente:any){
    if (this.socket && this.socket.connected) {
      this.socket.emit('join', { "_ricevente": ricevente });
    }
  }

  // lascia la room
  leaveChat(ricevente:any){
    if (this.socket && this.socket.connected) {
      this.socket.emit('leave', { "_ricevente": ricevente });
    }
  }

  // Ascolta gli eventi di chat
  onChatMessage(callback: (message: any) => void) {
    if (this.socket && this.socket.connected) {
      this.socket.on('chat', (data: any) => {
        callback(data);
      });
    }
  }

  // Ascolta gli eventi di notifica
  onNotificaMessage(callback: (message: any) => void) {
    if (this.socket && this.socket.connected) {
      this.socket.on('notifica', (data: any) => {
        callback(data);
      });
    }
  }

  // Invia un messaggio di chat
  sendMessage(message: any, ricevente:any) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('message', {"_message": message, "_ricevente": ricevente});
    }
  }

  // Invia una notifica
  // ricevente deve essere di questo tipo [[this.utente["id"], 0]] dove il primo argomento è la lista degli utenti 
  // il secondo può essere qualunque numero diverso da 1, se è 1 suona.
  // tipo si riferisce al tipo di notifica: chat, ordini ecc..
  sendNotify(ricevente:any, tipo:any) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('notify', {"_ricevente": ricevente, "_tipo":tipo});
    }
  }

  // Disconnessione
  disconnect() {
    if (this.socket && this.socket.connected) {
      this.socket.disconnect();
      this.socket = null;
      console.log('Disconnesso dal server WebSocket');
      // console.log(this.socket.connected); // Dovrebbe restituire "false"
    }
  }
}
